export default interface financialPlainSelected {
  name: string;
  siengeValue: string;
  id: number;
}

const financialPlainSelectedInitialValue: financialPlainSelected = {
  name: '',
  siengeValue: '',
  id: 0,
};

export { financialPlainSelectedInitialValue };
